import {
  getParkNode,
  getParkResNode,
  isImage,
  isSequenceFrame,
} from '@ps/bridge/qc/base'
import store from '@ps/store'
import { libTabNameList } from '@ps/store/workbench/resource-manager/config'
import qc from 'qc'
import { categoryList } from '@ps/store/workbench/resource-manager/config'
import qcGame from '@ps/bridge/qc/qc-game'
import assets from '@ps/bridge/qc/assets'
import gameIframe from '@ps/bridge/iframe/iframe'
import i18n from '@ps/lang'
import generateId from '@com/utils/generate-id'
import { scripts } from '@ps/bridge/qc/scripts'
import _ from 'lodash'
import router from '@ps/router'
import { initState } from '@ps/bridge/qc/node/xlz'
import { deg2rad } from '@com/utils/unit-converters/angle'
import * as layoutScript from '@ps/bridge/qc/scripts/layout'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { EditorDataScript, nodeTypes } from '@ps/bridge/qc/scripts/editor'
import { setNodeStyleMerge } from '@ps/bridge/qc/node/layout'

export enum ImageType {
  BG = 'BG', // 背景图
  ROAD = 'ROAD', // 道路图片
  AREA = 'AREA', // 道路区域
  MOVEDIR = 'MOVEDIR', // 运动方向
  ELEMENT = 'ELEMENT', // 第二步的元素
  EXIT_IMAGE = 'EXIT_IMAGE', // 图片类型出口
  EXIT_AREA = 'EXIT_AREA', // 区域类型出口
}
export enum ImageCategory {
  Image = 'Image',
  SequenceFrame = 'SequenceFrame',
}
// 道路类型
export enum RoadType {
  Road = 'Road',
  Area = 'Area',
}
// 道路放置规则
export enum RoadRule {
  EleOnRoad = 'EleOnRoad',
  EleNotOnRoad = 'EleNotOnRoad',
}
// 运动方向
export enum MoveDir {
  Forward = 'Forward',
  TurnLeft = 'TurnLeft',
  TurnRight = 'TurnRight',
  Left = 'Left',
  Right = 'Right',
}

export enum BackType {
  Disabled = 'Disabled',
  Turn = 'Turn',
  NoTurn = 'NoTurn',
}

export enum ElementType {
  Main = 'Main',
  Obs = 'Obs',
  Custom = 'Custom',
}

export enum ExitDir {
  ANY = 'ANY',
  FIXED = 'FIXED',
}

/** 素材研发的定义 */
/** 可行走实体对象的朝向方向 */
export enum MoveOrientation {
  /** 上 */
  Up,
  /** 下 */
  Down,
  /** 左 */
  Left,
  /** 右 */
  Right,
}

/** 可行走实体对象的行走方向 */
export enum MovableDirection {
  /** 前进 */
  Forward,
  /** 左转 */
  Left,
  /** 右转 */
  Right,
  /** 左调头 */
  TurnLeft,
  /** 右调头 */
  TurnRight,
}

// #region grid cell 网格信息

/** 每个网格的格子类型 */
export enum GridCellType {
  /** 障碍物 */
  Obstacle,
  /** 可行走的格子，可装实体对象的格子 */
  Movable,
  /** 自定义格子,根据策划需要做功能 */
  Custom,
}

/** 移动实体对象 */
export enum EntityType {
  /** 可移动实体对象 */
  Entity,
  /** 可移动实体对象占格 */
  Possess,
}

// #region movable 可行走格子
/** 扩展功能类型 */
export enum MovableType {
  /** 出口 */
  Exist,
  /** 转到出口，也可以理解为是一个自动寻路 */
  TurnExist,
}

export function addParkResource(config: {
  mainTip: boolean
  targetNode: qc.Node
  rules: string[]
  callback: any
}) {
  const data = {
    poolTabList: ['resourcePool', 'commonResource'],
    playComponentResource: true,
    currentTab: libTabNameList.PROJECT,
    currentChildTab: '',
    ...config,
    targetNode: {
      uuid: config.targetNode.uuid,
    },
  }
  if (config.callback) {
    data.callback = config.callback
  }
  console.log(data)
  store.commit('workspace/resourceManager/closeLibDialog')
  store.commit('workspace/resourceManager/updatePoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: 'commonResource',
    action: 'add',
  })
  store.commit('workspace/resourceManager/moveLibDialogNextToRight')
}

export function updateParkResource(node: qc.Node, callback: any) {
  const updateNode = node || store.state.workspace.game.activeNode
  const getCategory = (node: qc.Node) => {
    if (isImage(node)) {
      return categoryList.image.category
    } else if (isSequenceFrame(node)) {
      // 暂不支持序列帧节点资源替换
      return categoryList.aImage.category
    }
    return categoryList.image.category
  }
  const category = getCategory(updateNode)

  const onReplaced = () => {
    console.log('替换回调')
    //
    callback && callback()
  }
  const data = {
    parkResourceReplace: true,
    targetNode: {
      uuid: node.uuid,
    },
  }
  store.commit('workspace/resourceManager/assignPoolTabData', data)
  store.commit('workspace/resourceManager/openDialog', {
    category: category,
    action: 'update',
    onReplaced,
  })
  store.dispatch('workspace/resourceManager/getComponents', {
    category: category,
  })
  store.commit('workspace/resourceManager/moveDialogToRight')
}
// 添加辅助资源节点
export async function addTempResNodeByUrl(
  url: string | string[],
  sceneNode: qc.Node,
  imageCategory: string,
): qc.Node | null {
  const parkTempResNode = getParkResNode(sceneNode)
  if (!parkTempResNode) return null
  let node
  if (imageCategory === ImageCategory.Image) {
    node = qcGame.add.image(parkTempResNode)
    const asset = await assets.load({ url })
    const Texture = gameIframe.qc.Texture
    node.texture = new Texture(asset, 0)
  } else if (imageCategory === ImageCategory.SequenceFrame) {
    // 生成序列帧辅助节点,暂时没用，因为基础能力不支持序列帧替换
    node = qcGame.add.image(parkTempResNode)
    const mc = node.addScript(scripts.movieClip.name)
    mc.data = {}
    mc.data['action'] = url.join(',')
    mc.data['allFramePlaySmart'] = url.join(',')
    const defaultState = initState
    mc.defActionName = 'action'
    mc.playTime = defaultState.playTime
    mc.interval = defaultState.interval
    mc.autoDestory = defaultState.autoDestory
    mc.pingpong = defaultState.pingpong
    mc.defPlay = defaultState.defPlay
    mc.initData()
    mc.gotoAndPlay()
  }
  store.dispatch('workspace/game/updateActiveNode', {
    node,
    record: false,
  })
  return node
}
// 获取资源的类型
export function getResourceType(resource) {
  if (
    store.state.workspace.park.mapData.roadImages.findIndex(
      (item) => item.id === resource.id,
    ) > -1
  ) {
    return ImageType.ROAD
  } else if (resource.id === ImageType.AREA) {
    return ImageType.AREA
  } else if (resource.elementType) {
    return ImageType.ELEMENT
  } else if (resource.resType) {
    return resource.resType
  }
}
// 产出道路、运动方向图片资源数据
export function makeImageResData(
  id: string,
  resourceType: string,
  url: string,
  resourceUrl: string,
  imageName: string,
) {
  const data = {
    id,
    resourceType,
    visible: true,
    url,
    resourceUrl,
    imageName,
    scaleX: 1,
    scaleY: 1,
    pivotX: 0.5,
    pivotY: 0.5,
  }
  return data
}

// 产出道路区域资源数据
export function makeRoadAreaResData() {
  const data = {
    id: ImageType.AREA,
    color: 'rgba(82, 196, 26, 0.5)',
    imageName: i18n.t('workbench.park.step1Editor.edit3.area'),
  }
  return data
}
// 产出第二步元素资源数据
export function makeEleImageResData(
  id: string,
  resourceType: string,
  url: string,
  resourceUrl: string,
  urls: string,
  resourceUrls: string,
  imageName: string,
  elementType: string,
  gridNum: number,
  scaleX: number,
  scaleY: number,
  pivotX: number,
  pivotY: number,
) {
  let oriResource
  if (resourceType === ImageCategory.Image) {
    oriResource = [url]
  } else if (resourceType === ImageCategory.SequenceFrame) {
    oriResource = urls
  }
  const data = {
    id,
    resourceType,
    visible: true,
    url,
    resourceUrl,
    urls,
    resourceUrls,
    imageName,
    elementType,
    gridNum,
    scaleX,
    scaleY,
    pivotX,
    pivotY,
    ext: {
      filters: {
        // 滤镜
        blur: 0,
        hue: 0,
        luminance: 0,
        saturation: 0,
      },
      oriResource, // 原图绝对路径
    },
  }
  return data
}
export function getEmptyFilters() {
  const data = {
    // 滤镜
    blur: 0,
    hue: 0,
    luminance: 0,
    saturation: 0,
  }
  return data
}

// 产出格子道路图片数据
export function makeRoadImageData(
  resID: string,
  url: string,
  resourceUrl: string,
) {
  const data = {
    isRoad: true,
    road: {
      visible: true,
      rotation: 0,
      resID,
      url,
      resourceUrl,
    },
  }
  return data
}
// 产出格子道路区域数据
export function makeRoadAreaData(resID: string) {
  const data = {
    isRoad: true,
    road: {
      visible: true,
      rotation: 0,
      resID,
    },
  }
  return data
}
// 产出格子元素图片数据
export function makeElementImageData(
  resID: string,
  resourceType: string,
  url: string,
  resourceUrl: string,
  urls: string,
  resourceUrls: string,
  gridNum: number,
  elementType: string,
  moveDir: string,
  moveDirVisible: boolean,
  backType: string,
  scaleX: number,
  scaleY: number,
  pivotX: number,
  pivotY: number,
) {
  const data = {
    element: {
      resourceType,
      visible: true,
      rotation: 0,
      resID,
      url,
      resourceUrl,
      urls,
      resourceUrls,
      gridNum,
      elementType,
      moveDir,
      moveDirVisible,
      backType,
      scaleX,
      scaleY,
      pivotX,
      pivotY,
    },
  }
  return data
}

// 新增分类数据
export function makeCategoryData(
  categoryName: string,
  gridNum: number,
  elementType: string,
) {
  const data = {
    id: generateId(),
    name: categoryName,
    nameEn: categoryName,
    gridNum,
    elementType,
    resource: [],
  }
  return data
}
// 更新每个格子被多少个元素占据
export function refreshOccupyEleNum() {
  const renderData = store.state.workspace.park.mapData.renderData
  // 初始化占格数0
  for (let i = 0; i < renderData.length; i++) {
    for (let j = 0; j < renderData[i].length; j++) {
      renderData[i][j].occupyEleNum = 0
    }
  }
  for (let i = 0; i < renderData.length; i++) {
    for (let j = 0; j < renderData[i].length; j++) {
      const data = renderData[i][j]
      if (data.element) {
        data.occupyEleNum++
        if (data.element.gridNum > 1) {
          const rotation = data.element.rotation
          for (let k = 1; k < data.element.gridNum; k++) {
            if (rotation === 0 || rotation === 360) {
              if (i - k >= 0) {
                renderData[i - k][j].occupyEleNum++
              }
            } else if (rotation === -90 || rotation === 270) {
              if (j - k >= 0) {
                renderData[i][j - k].occupyEleNum++
              }
            } else if (rotation === -180 || rotation === 180) {
              if (i + k < renderData.length) {
                renderData[i + k][j].occupyEleNum++
              }
            } else if (rotation === 90 || rotation === -270) {
              if (j + k < renderData[i].length) {
                renderData[i][j + k].occupyEleNum++
              }
            }
          }
        }
      }
    }
  }
}
// 第二步中检查旋转有没有超出道路、整个盘面的情况和同一个格子被占用多个的情况
export function checkGridValidate() {
  const renderData = store.state.workspace.park.mapData.renderData
  const roadRule = store.state.workspace.park.mapData.roadRule
  refreshOccupyEleNum()
  for (let i = 0; i < renderData.length; i++) {
    for (let j = 0; j < renderData[i].length; j++) {
      const data = renderData[i][j]
      // 格子被多次占用，旋转导致
      if (data.occupyEleNum > 1) {
        return false
      }
      // 旋转元素导致超出整个盘面
      if (data.element && data.element.gridNum > 1) {
        const rotation = data.element.rotation
        for (let k = 1; k < data.element.gridNum; k++) {
          if (rotation === 0) {
            if (i - k < 0) {
              return false
            }
          } else if (rotation === -90 || rotation === 270) {
            if (j - k < 0) {
              return false
            }
          } else if (rotation === -180 || rotation === 180) {
            if (i + k >= renderData.length) {
              return false
            }
          } else if (rotation === 90 || rotation === -270) {
            if (j + k >= renderData[i].length) {
              return false
            }
          }
        }
      }
      // 旋转元素导致超出道路，或违法道路规则
      if (roadRule === RoadRule.EleOnRoad) {
        if (!data.isRoad && data.occupyEleNum > 0) {
          return false
        }
      } else {
        if (data.isRoad && data.occupyEleNum > 0) {
          return false
        }
      }
    }
  }
  return true
}

// 新增出口分类数据
export function makeExitCategoryData(categoryName: string, exitDir: string) {
  const data = {
    id: generateId(),
    enable: true,
    name: categoryName,
    nameEn: categoryName,
    exitDir,
    resource: [],
    bindMain: null,
  }
  return data
}

// 产出第三步元素图片资源数据
export function makeExitImageResData(
  id: string,
  resourceType: string,
  url: string,
  resourceUrl: string,
  imageName: string,
) {
  const data = {
    id,
    resourceType,
    visible: true,
    url,
    resourceUrl,
    imageName,
    resType: ImageType.EXIT_IMAGE,
  }
  return data
}

// 产出第三步元素区域资源数据
export function makeExitAreaResData(index: number) {
  const data = {
    id: generateId(),
    color: 'rgba(234, 27, 38, 1)',
    imageName: i18n.t('workbench.park.step3Editor.area') + index,
    resType: ImageType.EXIT_AREA,
  }
  return data
}

// 产出格子出口数据
export function makeExitGridData(
  resID: string,
  url: string,
  resourceUrl: string,
  color: string,
  exitType: string,
  exitDir: string,
  bindMain: string,
) {
  const data = {
    exit: {
      rotation: 0,
      resID,
      url,
      resourceUrl,
      color,
      exitType,
      exitDir,
      bindMain,
    },
  }
  return data
}
// 自定义元素每个大类
export function makeCustomEle(index: number) {
  const data = {
    id: generateId(),
    name:
      i18n.t('workbench.park.step2Editor.customEle.eleName', 'zh-cn') + index,
    nameEn:
      i18n.t('workbench.park.step2Editor.customEle.eleName', 'en') + index,
    enable: true,
    customCategory: [],
  }
  return data
}

// 图片宽高适配格子
function adapteImageSize(
  imageWidth: number,
  imageHeight: number,
  size: number,
  gridNum: number,
) {
  const containerWidth = size
  const containerHeight = size * gridNum
  const widthRatio = containerWidth / imageWidth
  const heightRatio = containerHeight / imageHeight
  const scaleFactor = Math.min(widthRatio, heightRatio)
  const width = imageWidth * scaleFactor
  const height = imageHeight * scaleFactor
  return {
    width,
    height,
  }
}
function adaptePictureSize(
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number,
) {
  const widthRatio = containerWidth / imageWidth
  const heightRatio = containerHeight / imageHeight
  const scaleFactor = Math.min(widthRatio, heightRatio)
  const width = imageWidth * scaleFactor
  const height = imageHeight * scaleFactor
  return {
    width,
    height,
  }
}
// 格子>1导致的xy偏移
function offsetForGridNum(size: number, gridNum: number, rotation: number) {
  const offset = (gridNum - 1) * (size / 2)
  const ans = {}
  if (rotation === 0 || rotation === 360) {
    ans.x = 0
    ans.y = offset
  } else if (rotation === -90 || rotation === 270) {
    ans.x = offset
    ans.y = 0
  } else if (rotation === 90 || rotation === -270) {
    ans.x = offset
    ans.y = 0
  } else if (rotation === -180 || rotation === 180) {
    ans.x = 0
    ans.y = offset
  }
  return ans
}
// 生成最终的游戏节点
export async function makeFinalGridBoard() {
  const sceneNode = store.state.workspace.park.sceneNode
  const size = store.state.workspace.park.mapData.grid.size
  const row = store.state.workspace.park.mapData.grid.row
  const column = store.state.workspace.park.mapData.grid.column
  const bg = store.state.workspace.park.mapData.bg
  let renderData = store.state.workspace.park.mapData.renderData
  const moveDirImages = store.state.workspace.park.mapData.moveDirImages
  const moveDirVisible = store.state.workspace.park.mapData.moveDirVisible
  const roadRule = store.state.workspace.park.mapData.roadRule
  renderData = gridDataTransform()

  const parkWidth = column * size
  const parkHeight = row * size

  const parkNode = getParkNode(sceneNode)
  const ped = editorScript.getScript(parkNode) as EditorDataScript
  ped.$data.nodeType = nodeTypes.park
  parkNode.width = parkWidth
  parkNode.height = parkHeight
  setNodeStyleMerge(parkNode, {
    width: parkWidth,
    height: parkHeight,
  })
  parkNode.removeChildren()

  // 背景图
  if (bg) {
    const bgImage = gameIframe.qcGame.add.image(parkNode)
    const asset = await assets.load({ url: bg.resourceUrl })
    const Texture = gameIframe.qc.Texture
    bgImage.texture = new Texture(asset, 0)
    // const { width, height } = adaptePictureSize(
    //   bgImage.width,
    //   bgImage.height,
    //   parkWidth,
    //   parkHeight,
    // )
    bgImage.width = bg.width
    bgImage.height = bg.height
    bgImage.x = 0
    bgImage.y = 0
    bgImage.scaleX = bg.scaleX
    bgImage.scaleY = bg.scaleY
    setParkStle(bgImage, {
      x: 0,
      y: 0,
      width: bg.width,
      height: bg.height,
      scaleX: bg.scaleX,
      scaleY: bg.scaleY,
    })
  }
  // 道路
  const roadNode = gameIframe.qcGame.add.node(parkNode)
  roadNode.name = 'roadNode'
  roadNode.width = parkWidth
  roadNode.height = parkHeight
  // 出口
  const exitNode = gameIframe.qcGame.add.node(parkNode)
  exitNode.name = 'exitNode'
  exitNode.width = parkWidth
  exitNode.height = parkHeight
  // 元素
  const elementNode = gameIframe.qcGame.add.node(parkNode)
  elementNode.name = 'elementNode'
  elementNode.width = parkWidth
  elementNode.height = parkHeight
  const psGridData = [] // 素材研发定义的数据结构
  // 初始化素材研发的数据结构
  for (let i = 0; i < row; i++) {
    psGridData[i] = []
    for (let j = 0; j < column; j++) {
      psGridData[i][j] = {}
    }
  }
  // 设置格子
  for (let i = 0; i < row; i++) {
    for (let j = 0; j < column; j++) {
      if (renderData[i][j].road) {
        let extra = null
        // 元素不放置道路上且是道路格子才是自动寻路格子
        if (roadRule === RoadRule.EleNotOnRoad) {
          extra = { type: MovableType.TurnExist }
        }
        if (renderData[i][j].road.resourceUrl) {
          // 道路图片
          const gridNode = gameIframe.qcGame.add.node(roadNode)
          gridNode.name = 'grid'
          gridNode.width = size
          gridNode.height = size
          gridNode.x = size / 2 + j * size - parkWidth / 2
          gridNode.y = size / 2 + i * size - parkHeight / 2
          const road = gameIframe.qcGame.add.image(gridNode)
          const asset = await assets.load({
            url: renderData[i][j].road.resourceUrl,
          })
          const Texture = gameIframe.qc.Texture
          road.texture = new Texture(asset, 0)
          road.name = 'road'
          road.resetNativeSize()
          const { width, height } = adapteImageSize(
            road.width,
            road.height,
            size,
            1,
          )
          road.width = width
          road.height = height
          road.x = 0
          road.y = 0
          setParkStle(road, {
            x: road.x,
            y: road.y,
            width: road.width,
            height: road.height,
          })
          const rad = deg2rad(renderData[i][j].road.rotation)
          gridNode.rotation = rad

          setParkStle(gridNode, {
            x: gridNode.x,
            y: gridNode.y,
            width: gridNode.width,
            height: gridNode.height,
            rotation: renderData[i][j].road.rotation,
          })
          // 素材研发
          psGridData[i][j] = Object.assign(
            {
              type: GridCellType.Movable,
              node: gridNode.uuid,
              extra: extra,
            },
            psGridData[i][j],
          )
        } else {
          // 道路区域
          psGridData[i][j] = Object.assign(
            {
              type: GridCellType.Movable,
              extra: extra,
            },
            psGridData[i][j],
          )
        }
      }
      if (renderData[i][j].element) {
        const gridNode = gameIframe.qcGame.add.node(elementNode)
        gridNode.name = 'grid'
        gridNode.width = size
        gridNode.height = size * renderData[i][j].element.gridNum
        gridNode.x = size / 2 + j * size - parkWidth / 2
        gridNode.y = size / 2 + i * size - parkHeight / 2
        const { x, y } = offsetForGridNum(
          size,
          renderData[i][j].element.gridNum,
          renderData[i][j].element.rotation,
        )
        gridNode.x += x
        gridNode.y += y
        let element
        if (
          renderData[i][j].element.resourceType === ImageCategory.SequenceFrame
        ) {
          // 序列帧
          element = gameIframe.qcGame.add.image(gridNode)
          const mc = element.addScript(scripts.movieClip.name)
          mc.data = {}
          mc.data['action'] = renderData[i][j].element.resourceUrls.join(',')
          mc.data['allFramePlaySmart'] =
            renderData[i][j].element.resourceUrls.join(',')
          const defaultState = initState
          mc.defActionName = 'action'
          mc.playTime = defaultState.playTime
          mc.interval = defaultState.interval
          mc.autoDestory = defaultState.autoDestory
          mc.pingpong = defaultState.pingpong
          mc.defPlay = defaultState.defPlay
          mc.initData()
          mc.gotoAndPlay()
        } else {
          // 普通图片
          element = gameIframe.qcGame.add.image(gridNode)
          const asset = await assets.load({
            url: renderData[i][j].element.resourceUrl,
          })
          const Texture = gameIframe.qc.Texture
          element.texture = new Texture(asset, 0)
        }
        element.name = 'element'
        element.resetNativeSize()
        const { width, height } = adapteImageSize(
          element.width,
          element.height,
          size,
          renderData[i][j].element.gridNum,
        )
        element.width = width
        element.height = height
        element.x = 0
        element.y = 0
        const rad = deg2rad(renderData[i][j].element.rotation)
        gridNode.rotation = rad
        element.scaleX = renderData[i][j].element.scaleX
        element.scaleY = renderData[i][j].element.scaleY

        setParkStle(element, {
          x: element.x,
          y: element.y,
          width: element.width,
          height: element.height,
          scaleX: element.scaleX,
          scaleY: element.scaleY,
        })
        setParkStle(gridNode, {
          x: gridNode.x,
          y: gridNode.y,
          width: gridNode.width,
          height: gridNode.height,
          rotation: renderData[i][j].element.rotation,
        })
        if (
          moveDirImages[renderData[i][j].element.moveDir] &&
          moveDirVisible &&
          renderData[i][j].element.elementType === ElementType.Main
        ) {
          const resourceUrl =
            moveDirImages[renderData[i][j].element.moveDir].resourceUrl
          const moveDir = gameIframe.qcGame.add.image(gridNode)
          const asset = await assets.load({
            url: resourceUrl,
          })
          const Texture = gameIframe.qc.Texture
          moveDir.texture = new Texture(asset, 0)
          moveDir.name = 'moveDir'
          moveDir.resetNativeSize()
          const { width, height } = adapteImageSize(
            moveDir.width,
            moveDir.height,
            size,
            renderData[i][j].element.gridNum,
          )
          moveDir.width = width
          moveDir.height = height
          moveDir.x = 0
          moveDir.y = 0
          moveDir.scaleX =
            moveDirImages[renderData[i][j].element.moveDir].scaleX
          moveDir.scaleY =
            moveDirImages[renderData[i][j].element.moveDir].scaleY
          moveDir.x += (renderData[i][j].element.pivotX - 0.5) * size
          moveDir.y +=
            (renderData[i][j].element.pivotY - 0.5) *
            size *
            renderData[i][j].element.gridNum
          setParkStle(moveDir, {
            x: moveDir.x,
            y: moveDir.y,
            width: moveDir.width,
            height: moveDir.height,
            scaleX: moveDir.scaleX,
            scaleY: moveDir.scaleY,
          })
        }
        // 素材研发
        let gridCellType
        if (renderData[i][j].element.elementType === ElementType.Main) {
          gridCellType = GridCellType.Movable
        } else if (renderData[i][j].element.elementType === ElementType.Obs) {
          gridCellType = GridCellType.Obstacle
        } else if (
          renderData[i][j].element.elementType === ElementType.Custom
        ) {
          gridCellType = GridCellType.Custom
        }
        let orientation
        if (
          renderData[i][j].element.rotation === 0 ||
          renderData[i][j].element.rotation === 360
        ) {
          orientation = MoveOrientation.Up
        } else if (
          renderData[i][j].element.rotation === -90 ||
          renderData[i][j].element.rotation === 270
        ) {
          orientation = MoveOrientation.Left
        } else if (
          renderData[i][j].element.rotation === -180 ||
          renderData[i][j].element.rotation === 180
        ) {
          orientation = MoveOrientation.Down
        } else if (
          renderData[i][j].element.rotation === 90 ||
          renderData[i][j].element.rotation === -270
        ) {
          orientation = MoveOrientation.Right
        }
        let moveDirection
        if (renderData[i][j].element.moveDir === MoveDir.Forward) {
          moveDirection = MovableDirection.Forward
        } else if (renderData[i][j].element.moveDir === MoveDir.Left) {
          moveDirection = MovableDirection.Left
        } else if (renderData[i][j].element.moveDir === MoveDir.Right) {
          moveDirection = MovableDirection.Right
        } else if (renderData[i][j].element.moveDir === MoveDir.TurnLeft) {
          moveDirection = MovableDirection.TurnLeft
        } else if (renderData[i][j].element.moveDir === MoveDir.TurnRight) {
          moveDirection = MovableDirection.TurnRight
        }
        let backFlatDirection = null
        if (renderData[i][j].element.backType === BackType.Disabled) {
          backFlatDirection = null
        } else if (renderData[i][j].element.backType === BackType.Turn) {
          backFlatDirection = true
        } else if (renderData[i][j].element.backType === BackType.NoTurn) {
          backFlatDirection = false
        }
        if (renderData[i][j].element.elementType === ElementType.Main) {
          psGridData[i][j] = Object.assign(psGridData[i][j], {
            type: gridCellType,
            node: gridNode.uuid,
            entity: {
              type: EntityType.Entity,
              identifier: getResCategoryID(renderData[i][j].element.resID),
              orientation: orientation,
              moveDirection: moveDirection,
              backFlatDirection: backFlatDirection,
            },
          })
        } else {
          psGridData[i][j] = Object.assign(psGridData[i][j], {
            type: gridCellType,
            node: gridNode.uuid,
            identifier: getResCategoryID(renderData[i][j].element.resID),
          })
        }
        // 占格数大于1的主元素
        if (renderData[i][j].element.gridNum > 1) {
          if (
            renderData[i][j].element.rotation === 0 ||
            renderData[i][j].element.rotation === 360 ||
            renderData[i][j].element.rotation === -180 ||
            renderData[i][j].element.rotation === 180
          ) {
            for (let k = 1; k < renderData[i][j].element.gridNum; k++) {
              if (renderData[i][j].element.elementType === ElementType.Main) {
                psGridData[i + k][j] = Object.assign(psGridData[i + k][j], {
                  type: GridCellType.Movable,
                  node: gridNode.uuid,
                  entity: {
                    type: EntityType.Possess,
                    rowIndex: i,
                    colIndex: j,
                  },
                })
              } else {
                psGridData[i + k][j] = Object.assign(psGridData[i + k][j], {
                  type: gridCellType,
                  node: gridNode.uuid,
                  identifier: getResCategoryID(renderData[i][j].element.resID),
                })
              }
            }
          } else if (
            renderData[i][j].element.rotation === -90 ||
            renderData[i][j].element.rotation === 270 ||
            renderData[i][j].element.rotation === 90 ||
            renderData[i][j].element.rotation === -270
          ) {
            for (let k = 1; k < renderData[i][j].element.gridNum; k++) {
              if (renderData[i][j].element.elementType === ElementType.Main) {
                psGridData[i][j + k] = Object.assign(psGridData[i][j + k], {
                  type: GridCellType.Movable,
                  node: gridNode.uuid,
                  entity: {
                    type: EntityType.Possess,
                    rowIndex: i,
                    colIndex: j,
                  },
                })
              } else {
                psGridData[i][j + k] = Object.assign(psGridData[i][j + k], {
                  type: gridCellType,
                  node: gridNode.uuid,
                  identifier: getResCategoryID(renderData[i][j].element.resID),
                })
              }
            }
          }
        }
      }
      if (renderData[i][j].exit) {
        const bindMainRes = getBindMainResIDByResID(renderData[i][j].exit.resID)
        let orientation = null
        if (renderData[i][j].exit.exitDir === ExitDir.FIXED) {
          if (
            renderData[i][j].exit.rotation === 0 ||
            renderData[i][j].exit.rotation === 360
          ) {
            orientation = MoveOrientation.Up
          } else if (
            renderData[i][j].exit.rotation === -90 ||
            renderData[i][j].exit.rotation === 270
          ) {
            orientation = MoveOrientation.Left
          } else if (
            renderData[i][j].exit.rotation === -180 ||
            renderData[i][j].exit.rotation === 180
          ) {
            orientation = MoveOrientation.Down
          } else if (
            renderData[i][j].exit.rotation === 90 ||
            renderData[i][j].exit.rotation === -270
          ) {
            orientation = MoveOrientation.Right
          }
        }
        if (renderData[i][j].exit.resourceUrl) {
          // 出口是图片
          // const gridNode = gameIframe.qcGame.add.node(exitNode)
          // gridNode.name = 'grid'
          // gridNode.width = size
          // gridNode.height = size
          // gridNode.x = size / 2 + j * size - parkWidth / 2
          // gridNode.y = size / 2 + i * size - parkHeight / 2
          // const exit = gameIframe.qcGame.add.image(gridNode)
          // const asset = await assets.load({
          //   url: renderData[i][j].exit.resourceUrl,
          // })
          // const Texture = gameIframe.qc.Texture
          // exit.texture = new Texture(asset, 0)
          // exit.name = 'exit'
          // exit.resetNativeSize()
          // const { width, height } = adapteImageSize(
          //   exit.width,
          //   exit.height,
          //   size,
          //   1,
          // )
          // exit.width = width
          // exit.height = height
          // exit.x = 0
          // exit.y = 0
          // const rad = deg2rad(renderData[i][j].exit.rotation)
          // gridNode.rotation = rad

          // setParkStle(gridNode, {
          //   x: gridNode.x,
          //   y: gridNode.y,
          //   width: gridNode.width,
          //   height: gridNode.height,
          //   rotation: renderData[i][j].exit.rotation,
          // })
          // setParkStle(exit, {
          //   x: exit.x,
          //   y: exit.y,
          //   width: exit.width,
          //   height: exit.height,
          // })
          // 素材研发
          psGridData[i][j] = Object.assign(
            {},
            {
              type: GridCellType.Movable,
              // node: gridNode.uuid,
              extra: { type: MovableType.Exist, identifiers: bindMainRes },
            },
            psGridData[i][j],
          )
          psGridData[i][j].extra = {}
          psGridData[i][j].extra.type = MovableType.Exist // 出口类型覆盖
          psGridData[i][j].extra.identifiers = bindMainRes
          psGridData[i][j].extra.orientation = orientation
        } else {
          // 出口是区域
          psGridData[i][j] = Object.assign(
            {},
            {
              type: GridCellType.Movable,
              extra: { type: MovableType.Exist, identifiers: bindMainRes },
            },
            psGridData[i][j],
          )
          psGridData[i][j].extra = {}
          psGridData[i][j].extra.type = MovableType.Exist // 出口类型覆盖
          psGridData[i][j].extra.identifiers = bindMainRes
          psGridData[i][j].extra.orientation = orientation
        }
      }
      // 空格子
      if (
        !renderData[i][j].road &&
        !renderData[i][j].element &&
        !renderData[i][j].exit &&
        Object.keys(psGridData[i][j]).length === 0
      ) {
        psGridData[i][j] = { type: GridCellType.Movable }
      }
      // 元素放置道路上，非道路的格子就设为障碍物
      if (!renderData[i][j].road && roadRule === RoadRule.EleOnRoad) {
        psGridData[i][j] = { type: GridCellType.Obstacle }
      }
    }
  }
  saveGridConfig2ParkComponent(psGridData)
}
function setParkStle(node: qc.Node, style) {
  const layoutScriptData = layoutScript.getScript(node)
  const layoutData = layoutScriptData.layoutData
  const layout = layoutScriptData.layout
  let tStyle = []
  layoutData.pdef = {}
  layoutData.ldef = {}
  for (const i in style) {
    tStyle.push(`${i}:${style[i]}`)
    layoutData.pdef[i] = style[i]
    layoutData.ldef[i] = style[i]
  }
  tStyle = tStyle.join(',')
  layout.pdef = tStyle
  layout.ldef = tStyle
  layoutScriptData?.refresh()
}
function getBindMainResIDByResID(resID: string) {
  const exitEles = store.state.workspace.park.mapData.exitEles
  const mainEles = store.state.workspace.park.mapData.mainEles
  for (const i in exitEles) {
    for (const j in exitEles[i].resource) {
      if (exitEles[i].resource[j].id === resID) {
        const bindMainId = exitEles[i].resource[j].bindMain
        // 分组id就可以了,是数组
        return bindMainId
      }
    }
  }
  return []
}
// 保存格子数据到脚本中
export function saveMapData2ParkComponent() {
  const sceneNode = store.state.workspace.park.sceneNode
  const mapData = store.state.workspace.park.mapData
  const parkNode = getParkNode(sceneNode)
  const parkComponent = parkNode.getScript(scripts.park.name)
  parkComponent.psConfig = _.cloneDeep(mapData)
}

export function getImageUrl(node: qc.Node) {
  let url = ''
  if (isSequenceFrame(node)) {
    url = getSequenceFrameFirstFrame(node)
  } else {
    url = _.get(node, 'texture.atlas.img.currentSrc') || ''
  }
  return url
}

export function getSequenceFrameFirstFrame(node: qc.Node) {
  const mc = node.getScript(scripts.movieClip.name)
  const list = mc.data[mc.currentFrameName].split(',')
  if (list.length > 0) {
    let url = list[0].replace(/\.bin$/, '.png')
    url = `/project/preview/${router.currentRoute.query.id}/${url}`
    return url
  }
  return ''
}

export function getSequenceFrameAllImage(node: qc.Node) {
  const mc = node.getScript(scripts.movieClip.name)
  const list = mc.data[mc.currentFrameName].split(',')
  const urls = list.map((item: string) => {
    return item.replace(/\.bin$/, '.png')
  })
  return { urlList: urls, resourceUrlList: list }
}
// 格子里是否有该主元素分组的资源
export function hasMainResInGrid(categoryId: string) {
  const renderData = store.state.workspace.park.mapData.renderData
  const mainEles = store.state.workspace.park.mapData.mainEles
  const mainEle = mainEles.find((item) => item.id === categoryId)
  const idList = mainEle.resource.map((item) => item.id)
  for (const i in renderData) {
    for (const j in renderData[i]) {
      const item = renderData[i][j]
      if (item.element && idList.indexOf(item.element.resID) > -1) {
        return true
      }
    }
  }
  return false
}
// 获取图片的相对路径
export function getImageRelativeUrl(url: string, resourceUrl: string) {
  const ext = url.slice(url.lastIndexOf('.'))
  return resourceUrl.replace(/\.bin$/, ext)
}
// 获取图片的绝对路径
export function getAbsoluteUrl(url: string) {
  return `/project/preview/${router.currentRoute.query.id}/${url}`
}
// 根据格子的资源id获取其道路资源
export function getRoadImageRes(id: string) {
  const roadImages = store.state.workspace.park.mapData.roadImages
  return roadImages.find((item) => item.id === id)
}
// 根据格子的资源id获取其元素资源
export function getElementRes(id: string) {
  const mainEles = store.state.workspace.park.mapData.mainEles
  let res
  for (const i in mainEles) {
    res = mainEles[i].resource.find((item) => item.id === id)
    if (res) {
      return res
    }
  }

  const obsEles = store.state.workspace.park.mapData.obsEles
  for (const i in obsEles) {
    res = obsEles[i].resource.find((item) => item.id === id)
    if (res) {
      return res
    }
  }

  const customEles = store.state.workspace.park.mapData.customEles
  customEles.forEach((item) => {
    item.customCategory.forEach((customCategory) => {
      res = customCategory.resource.find((resource) => resource.id === id)
    })
  })
  if (res) return res
  return null
}
// 根据格子的资源id获取其出口资源
export function getExitRes(id: string) {
  const exitEles = store.state.workspace.park.mapData.exitEles
  let res
  for (const i in exitEles) {
    res = exitEles[i].resource.find((item) => item.id === id)
    if (res) {
      return res
    }
  }
  return null
}
export function saveGridConfig2ParkComponent(gridData) {
  console.log(gridData)
  const sceneNode = store.state.workspace.park.sceneNode
  const row = store.state.workspace.park.mapData.grid.row
  const column = store.state.workspace.park.mapData.grid.column
  const size = store.state.workspace.park.mapData.grid.size
  const parkNode = getParkNode(sceneNode)
  const parkComponent = parkNode.getScript(scripts.park.name)
  parkComponent.gridConfig = {
    cellWidth: size,
    cellHeight: size,
    rowCount: row,
    colCount: column,
    datas: gridData,
  }
}
// 转换为素材研发的数据
export function gridDataTransform() {
  const renderData = store.state.workspace.park.mapData.renderData
  const row = store.state.workspace.park.mapData.grid.row
  const column = store.state.workspace.park.mapData.grid.column
  const gridData = []
  for (let i = 0; i < row; i++) {
    gridData[i] = []
    for (let j = 0; j < column; j++) {
      gridData[i][j] = {}
      if (renderData[i][j].road) {
        gridData[i][j].road = Object.assign({}, renderData[i][j].road)
      }
      if (renderData[i][j].element) {
        const gridNum = renderData[i][j].element.gridNum
        if (gridNum === 1) {
          gridData[i][j].element = Object.assign({}, renderData[i][j].element)
        } else {
          if (renderData[i][j].element.rotation === 0) {
            gridData[i - gridNum + 1][j].element = Object.assign(
              {},
              renderData[i][j].element,
            )
          } else if (
            renderData[i][j].element.rotation === -90 ||
            renderData[i][j].element.rotation === 270
          ) {
            gridData[i][j - gridNum + 1].element = Object.assign(
              {},
              renderData[i][j].element,
            )
          } else {
            gridData[i][j].element = Object.assign({}, renderData[i][j].element)
          }
        }
      }
      if (renderData[i][j].exit) {
        gridData[i][j].exit = Object.assign({}, renderData[i][j].exit)
      }
    }
  }
  console.log(gridData)
  return gridData
}

function getResCategoryID(id: string) {
  const mainEles = store.state.workspace.park.mapData.mainEles
  for (const i in mainEles) {
    const ids = mainEles[i].resource.map((item) => item.id)
    if (ids.indexOf(id) > -1) {
      return mainEles[i].id
    }
  }
  const obsEles = store.state.workspace.park.mapData.obsEles
  for (const i in obsEles) {
    const ids = obsEles[i].resource.map((item) => item.id)
    if (ids.indexOf(id) > -1) {
      return obsEles[i].id
    }
  }
  const customEles = store.state.workspace.park.mapData.customEles
  for (const i in customEles) {
    const customCategory = customEles[i].customCategory
    for (const j in customCategory) {
      const ids = customCategory[j].resource.map((item) => item.id)
      if (ids.indexOf(id) > -1) {
        return customCategory[j].id
      }
    }
  }
  return null
}
// 链接格式转为bin
export function transform2bin(url: string) {
  return url.replace(/\.(png|jpg)$/i, '.bin')
}
